import {PlayerColor} from '@colonist/game-states'

export module GameColor {

    export enum Color {
        PrimaryBlue0, PrimaryBlue1, PrimaryBlue2, PrimaryBlue3, PrimaryBlue4, PrimaryBlue5, PrimaryBlue6, PrimaryBlue7, PrimaryBlue8, PrimaryBlue9,
        PrimaryOrange0,
        Gray0, Gray1, Gray2, Gray3, Gray4,

        White,
        PlayerGoldBgLight,

        PlayerRedBgDark,
        PlayerBlueBgDark,
        PlayerGreenBgDark,
        PlayerOrangeBgDark,
        PlayerBlackBgDark,
        PlayerBronzeBgDark,
        PlayerSilverBgDark,
        PlayerGoldBgDark,
        PlayerWhiteDark,
        PlayerPurpleDark,
        PlayerMyscticBlueDark,
        PlayerPinkDark,

        GreenLink, GreenLight, GreenDark, GreenStatusCheckmark, RedLight, RedDark,
        Sea, DarkGrey, OffWhite,

        GrayScale0, GrayScale1, GrayScale2, GrayScale3, GrayScale4, GrayScale5,
        GrayScale6, GrayScale7, GrayScale8, GrayScale9, GrayScale10, GrayScale11,
        GrayScale12, GrayScale13, GrayScale14, GrayScale15, GrayScale16, GrayScale17,
        GrayScale18, GrayScale19, GrayScale20, GrayScale21, GrayScale22, GrayScale23,
        GrayScale24, GrayScale25,

        CardViewFadedTint,
    }

    export function getColor(color: Color): string {
        switch(color) {
            case Color.PrimaryBlue0: return '#328DC0'
            case Color.PrimaryBlue1: return '#c2e6f2'
            case Color.PrimaryBlue2: return '#5cc3e5'
            case Color.PrimaryBlue3: return '#2a748c'
            case Color.PrimaryBlue4: return '#263940'
            case Color.PrimaryBlue5: return '#177FDE'
            case Color.PrimaryBlue6: return '#1B446A'
            case Color.PrimaryBlue7: return '#1e90ff'
            case Color.PrimaryBlue8: return '#4c698b'
            case Color.PrimaryBlue9: return '#15324E'

            case Color.PrimaryOrange0: return '#F06800'

            case Color.White: return '#FFFFFF'
            case Color.PlayerGoldBgLight: return '#EBD300'

            case Color.Gray0: return '#323232'
            case Color.Gray1: return '#666666'
            case Color.Gray2: return '#cccccc'
            case Color.Gray3: return '#f8f8f8'
            case Color.Gray4: return '#000003'

            // Used in player chat color
            case Color.PlayerBlueBgDark: return '#223697'
            case Color.PlayerRedBgDark: return '#E27174'
            case Color.PlayerGreenBgDark: return '#62B95D'
            case Color.PlayerOrangeBgDark: return '#E09742'
            case Color.PlayerBlackBgDark: return '#3e3e3e'
            case Color.PlayerBronzeBgDark: return '#a86755'
            case Color.PlayerSilverBgDark: return '#848484'
            case Color.PlayerGoldBgDark: return '#c7ae61'
            case Color.PlayerPurpleDark: return '#9D55AF'
            case Color.PlayerMyscticBlueDark: return '#256CA7'
            case Color.PlayerWhiteDark: return '#9E9E9E'
            case Color.PlayerPinkDark: return '#F170CD'

            case Color.GreenLink: return '#48ff00'
            case Color.GreenLight: return '#cde7ca'
            case Color.GreenDark: return '#0bb000'
            case Color.GreenStatusCheckmark: return '#1A9118'
            case Color.RedLight: return '#FFD8D9'
            case Color.RedDark: return '#c00006'
            case Color.DarkGrey: return '#46616E'
            case Color.OffWhite: return '#fffde1'

            case Color.Sea: return '#0967A6'

            case Color.GrayScale0: return '#000000'
            case Color.GrayScale1: return '#0A0A0A'
            case Color.GrayScale2: return '#141414'
            case Color.GrayScale3: return '#1F1F1F'
            case Color.GrayScale4: return '#292929'
            case Color.GrayScale5: return '#333333'
            case Color.GrayScale6: return '#3D3D3D'
            case Color.GrayScale7: return '#474747'
            case Color.GrayScale8: return '#525252'
            case Color.GrayScale9: return '#5C5C5C'
            case Color.GrayScale10: return '#666666'
            case Color.GrayScale11: return '#707070'
            case Color.GrayScale12: return '#7A7A7A'
            case Color.GrayScale13: return '#858585'
            case Color.GrayScale14: return '#8F8F8F'
            case Color.GrayScale15: return '#999999'
            case Color.GrayScale16: return '#A3A3A3'
            case Color.GrayScale17: return '#ADADAD'
            case Color.GrayScale18: return '#B8B8B8'
            case Color.GrayScale19: return '#C2C2C2'
            case Color.GrayScale20: return '#CCCCCC'
            case Color.GrayScale21: return '#D6D6D6'
            case Color.GrayScale22: return '#E0E0E0'
            case Color.GrayScale23: return '#EBEBEB'
            case Color.GrayScale24: return '#F5F5F5'
            case Color.GrayScale25: return '#FFFFFF'

            case Color.CardViewFadedTint: return '#ADADAD'
        }
    }

    export function getColorHexValue(color: Color): number {
        const myColor = getColor(color)
        return parseInt(myColor.slice(1), 16)
    }

    export function getPlayerBGDarkHash(playerColor: PlayerColor): string {
        switch(playerColor) {
            case PlayerColor.Blue: return getColor(Color.PlayerBlueBgDark)
            case PlayerColor.Red: return getColor(Color.PlayerRedBgDark)
            case PlayerColor.Orange: return getColor(Color.PlayerOrangeBgDark)
            case PlayerColor.Green: return getColor(Color.PlayerGreenBgDark)
            case PlayerColor.Black: return getColor(Color.PlayerBlackBgDark)
            case PlayerColor.Bronze: return getColor(Color.PlayerBronzeBgDark)
            case PlayerColor.Silver: return getColor(Color.PlayerSilverBgDark)
            case PlayerColor.Gold: return getColor(Color.PlayerGoldBgDark)
            case PlayerColor.MysticBlue: return getColor(Color.PlayerMyscticBlueDark)
            case PlayerColor.White: return getColor(Color.PlayerWhiteDark)
            case PlayerColor.Purple: return getColor(Color.PlayerPurpleDark)
            case PlayerColor.Pink: return getColor(Color.PlayerPinkDark)
            case PlayerColor.None: return getColor(Color.White)
        }
    }

    export function getPlayerBGDarkHashForMobile(playerColor: PlayerColor): string {
        switch(playerColor) {
            case PlayerColor.Blue: return '#2F8EFF'
            case PlayerColor.Red: return '#FF4D52'
            case PlayerColor.Orange: return '#FF6C0A'
            case PlayerColor.Green: return '#05BF00'
            case PlayerColor.Black: return '#808080'
            case PlayerColor.Bronze: return '#B94E00'
            case PlayerColor.Silver: return '#BCBEC0'
            case PlayerColor.Gold: return '#F9D900'
            case PlayerColor.MysticBlue: return '#80DBFF'
            case PlayerColor.White: return '#FFFFFF'
            case PlayerColor.Purple: return '#C067FF'
            case PlayerColor.Pink: return getColor(Color.PlayerPinkDark)
            case PlayerColor.None: return '#FFFFFF'
        }
    }

    export function getLighterGradientOfPlayerColor(playerColor: PlayerColor): string {
        switch(playerColor) {
            case PlayerColor.Blue: return '#01A9FF'
            case PlayerColor.Red: return '#ED3437'
            case PlayerColor.Orange: return '#FF963B'
            case PlayerColor.Green: return '#7EC985'
            case PlayerColor.Bronze: return '#DD7B62'
            case PlayerColor.Silver: return '#D4D4D4'
            case PlayerColor.Gold: return '#EBD300'
            case PlayerColor.Black: return '#7C7D80'
            case PlayerColor.Purple: return '#D04DF7'
            case PlayerColor.MysticBlue: return '#0C7DBC'
            case PlayerColor.White: return '#CFEEF2'
            case PlayerColor.Pink: return 'pink'
            case PlayerColor.None: return '#000000'
        }
    }

    export function getDarkerGradientOfPlayerColor(playerColor: PlayerColor): string {
        switch(playerColor) {
            case PlayerColor.Blue: return '#1216CE'
            case PlayerColor.Red: return '#B90101'
            case PlayerColor.Orange: return '#DE6800'
            case PlayerColor.Green: return '#18A101'
            case PlayerColor.Bronze: return '#9B3918'
            case PlayerColor.Silver: return '#686868'
            case PlayerColor.Gold: return '#F37B24'
            case PlayerColor.Black: return '#464547'
            case PlayerColor.Purple: return '#7553AD'
            case PlayerColor.MysticBlue: return '#53C1FF'
            case PlayerColor.White: return '#88ADAC'
            case PlayerColor.Pink: return 'pink'
            case PlayerColor.None: return '#000000'
        }
    }

    // export function getPlayerBGDarkHexValue(playerColor: PlayerColor): number {
    //     switch (playerColor) {
    //         case PlayerColor.Blue: return getColorHexValue(Color.PlayerBlueBgDark)
    //         case PlayerColor.Red: return getColorHexValue(Color.PlayerRedBgDark)
    //         case PlayerColor.Orange: return getColorHexValue(Color.PlayerOrangeBgDark)
    //         case PlayerColor.Green: return getColorHexValue(Color.PlayerGreenBgDark)
    //         case PlayerColor.None: return getColorHexValue(Color.Gray4)
    //     }
    // }

}
